import { DevelopmentalCard } from "./DevelopmentalCard";
import { getMilestones, getActivities } from "@/data/developmental";
import { AgeGroup } from "@/types/developmental";

interface DevelopmentalContentProps {
  age: AgeGroup;
}

export const DevelopmentalContent = ({ age }: DevelopmentalContentProps) => {
  const milestones = getMilestones(age);
  const activities = getActivities(age);

  return (
    <div className="space-y-6">
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        <DevelopmentalCard
          title="Motor Skills"
          age={age}
          milestones={milestones.motor}
          activities={activities.motor}
        />
        <DevelopmentalCard
          title="Language Skills"
          age={age}
          milestones={milestones.language}
          activities={activities.language}
        />
        <DevelopmentalCard
          title="Cognitive Development"
          age={age}
          milestones={milestones.cognitive}
          activities={activities.cognitive}
        />
        <DevelopmentalCard
          title="Independent Skills"
          age={age}
          milestones={milestones.independent}
          activities={activities.independent}
        />
        <DevelopmentalCard
          title="Social and Emotional Skills"
          age={age}
          milestones={milestones.social}
          activities={activities.social}
        />
      </div>
    </div>
  );
};